import React from "react";
import { ScrollRestoration } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import styles from "./Projects.module.css";
import ProjectComponent from "../../components/Projects/ProjectComponent";
import SkipLinks from "../../components/SkipLinks/SkipLinks";
export default function Projects() {
	return (
		<>
			<SkipLinks />
			<Navbar />
			<ScrollRestoration />
			<div className={styles.container}>
				<ProjectComponent />
			</div>
		</>
	);
}
